"use strict";

module.exports = require("./is-implemented")()
	? require("ext/global-this").Symbol
	: require("./polyfill");



//////////////////
// WEBPACK FOOTER
// ./~/es6-symbol/index.js
// module id = 332
// module chunks = 9